<script>
  import { _ } from './services/i18n'
</script>

<section id="authors" class="container">
  <h2>{$_('authors.title')}</h2>
  <p class="desc">{$_('authors.desc')}</p>
  <p class="desc1">{$_('authors.desc1')}</p>
  <div class="box-container">
    <div class="box">
      <h3>{$_('authors.benefits')}</h3>
      <p>{$_('authors.benefits1')}</p>
      <p>{$_('authors.benefits2')}</p>
      <p>{$_('authors.benefits3')}</p>
      <p>{$_('authors.benefits4')}</p>
      <p>{$_('authors.benefits5')}</p>
    </div>
    <div class="box">
      <h3>{$_('authors.weWill')}</h3>
      <p>{$_('authors.weWill1')}</p>
      <p>{$_('authors.weWill2')}</p>
      <p>{$_('authors.weWill3')}</p>
      <p>{$_('authors.weWill4')}</p>
      <p>{$_('authors.weWill5')}</p>
      <p>{$_('authors.weWill6')}</p>
    </div>
  </div>
</section>

<style>
  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4.5rem 1rem;
  }
  h2 {
    font-size: 2rem;
    font-weight: 500;
    padding-bottom: 2rem;
  }
  .desc {
    text-align: center;
    width: 600px;
  }
  .desc1 {
    text-align: center;
    width: 600px;
    padding-bottom: 2rem;
  }
  .box-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .box {
    background-color: var(--mainWhite);
    background-color: rgb(20, 24, 36);
    border-top: 5px solid var(--primaryColor);
    padding: 1rem;
    margin: 1rem;
    min-height: 256px;
    flex-basis: 37%;
  }
  h3 {
    font-size: 1.5rem;
    padding-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--mainWhite);
  }
  .box p {
    color: var(--mainWhite);
  }

  @media (max-width: 1020px) {
    .box-container {
      flex-direction: column;
    }
    .box {
      width: 60%;
    }
  }
  @media (max-width: 768px) {
    .container {
      padding-bottom: 0;
  }
    .box {
      width: 100%;
      text-align: center;
      margin: 1rem 0;
    }
    .desc {
      width: 100%;
    }
    .box p {
      text-align: center;
    }
    h3 {
      justify-content: center;
    }
  }
</style>
